import { FieldDefinition } from "../../../../component/form/field-definition";

export const studentSubmitFieldDefinitions: FieldDefinition[] = [
    {
        id: "badgeAcceptanceCriteria",
        name: "Session acceptance criteria",
        type: "info",
        required: false,
        disabled: false,
        fullInput: true
    },
    {
        id: "workingBadgePath",
        name: "Badge path",
        type: "text",
        required: false,
        disabled: false
    },
    {
        id: "comment",
        name: "Add comment",
        type: "text",
        required: false,
        disabled: false
    }
];